import { env } from "@infra/implementations/config/env";

export const IS_PROD = env.environmentName === "production";
export const IS_DEV = env.environmentName === "development";
export const IS_DEV_SENTRY = env.environmentName === "development-sentry";
export const DEBUG = IS_DEV || IS_DEV_SENTRY || env.debug;
